import { registerModuleReducer } from 'utils/modules/reducer';

import reducer from './reducer';

registerModuleReducer('unsynchedWarning', reducer);

export { getStatuses } from './selectors';
export { default as ExportSynchronizationStatus } from './sync-status';
export { default as UnsynchedWarning } from './unsynched-warning';
